import { ApiClientService, EntityApiService, SearchResponseType } from '@dfl/react-security';
import { RequestConfig } from '@dfl/react-security/dist/cjs/types/types/axios';
import fileDownload from 'js-file-download';
import { format } from 'date-fns';
import { IAbstractOrder } from 'modules/sales/common/interfaces/IOrder';
import { parserManyOrders } from 'modules/sales/common/constants/order-table.parsing';

export class AbstractOrderService<T extends IAbstractOrder> extends EntityApiService<T> {
  search = (params?: any, config?: RequestConfig): Promise<SearchResponseType<T>> => {
    const size = params?.size || 20;
    return this.handleSearchResponse(
      ApiClientService.post(this.getPath('/search?admin=true'), params, config),
      size,
    ).then(parserManyOrders);
  };

  getOne = (id: string, config?: RequestConfig): Promise<T> => {
    return this.handleResponse(ApiClientService.get(this.getPath(`/${id}?admin=true`), config));
  };

  getOneWIthStatusHistory = (id: string, config?: RequestConfig): Promise<T> => {
    return this.getOne(id, config).then((data: any) => {
      data.owner = data.statusHistory.find((act: any) => act.user?._id === data.owner)?.user || data.owner;
      data.statusHistory = data.statusHistory.filter(
        ({ status }: any) => !status?.type?.match(/CREATED|PENDING_PAYMENT/),
      );
      return data;
    });
  };

  exportToExcel = (filters: any) => {
    const time = format(new Date(), 'dd-MM-yyyy');
    const name = `orders-${time}.xlsx`;
    return ApiClientService.post(this.getPath('/excel'), { filters }, { responseType: 'blob' }).then(
      ({ data }) => { fileDownload(data, name); },
    );
  };
}
